import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { i18n } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import getSearchTip from '../helpers/get-search-tip';

const { Box, Search, FieldStatus } = designSystem;

function StockGallerySearch({
  searchQuery = '',
  searchPlaceholder = '',
  isMobile = false,
  onSearch,
  onFocus,
}) {
  const currentLocale = useSelector(i18n.accessors.getLocale);
  const searchTip = useMemo(() => getSearchTip(currentLocale), [currentLocale]);

  return (
    <Box padding={isMobile ? 'spacing-xs' : 'spacing-m'} paddingBottom="spacing-4-xs">
      <Search
        defaultValue={searchQuery}
        placeholder={searchPlaceholder}
        disableClearWhileInput
        onChange={onSearch}
        onClear={onSearch}
        onFocus={onFocus}
      />
      {searchTip && <FieldStatus text={searchTip} />}
    </Box>
  );
}

StockGallerySearch.propTypes = {
  searchQuery: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  isMobile: PropTypes.bool,
  onSearch: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
};

export default StockGallerySearch;
